import { Record } from 'immutable';
import type { ReactNode } from 'react';

/** `btnPressed` is the pressed button's label, or `Escape` when the alert is dismissed. */
export type AlertDialogResult<Button extends string = string> = { btnPressed: Button | 'Escape' };

export type AlertDialogCallback<Button extends string = string> = (result: AlertDialogResult<Button>) => void;

export type AlertDialogProps = {
  buttons: readonly string[];
  content: ReactNode;
  /** Closing removes the root UI dialog with this id. */
  dialogId: string;
  onClose?: AlertDialogCallback | null;
  /** Unset shows StdDialog's close button. */
  showCloseButton?: boolean;
  /** A text button at the left of the actions. */
  tertiaryButton?: string;
  title: string;
  titleIcon?: ReactNode;
};

export const mkAlertDialogProps = Record<Required<Omit<AlertDialogProps, 'dialogId'>>>({
  title: 'Alert',
  content: '',
  onClose: null,
  buttons: ['Yes', 'No'],
  titleIcon: null,
  showCloseButton: false,
  tertiaryButton: '',
});

export const DIALOG_TYPE = 'DIALOG_ALERT';
